import createIcon from '../../createIcon';

/**
 * @component @name ImageSearch
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcuNzkgMTNWMjBIMy43OTAwNFY2SDguODEwMDRDOC44NjAwNCA1LjI5IDkuMDMwMDQgNC42MiA5LjI5MDA0IDRIMy43OTAwNEMyLjY5MDA0IDQgMS43OTAwNCA0LjkgMS43OTAwNCA2VjIwQzEuNzkwMDQgMjEuMSAyLjY5MDA0IDIyIDMuNzkwMDQgMjJIMTcuNzlDMTguODkgMjIgMTkuNzkgMjEuMSAxOS43OSAyMFYxNUwxNy43OSAxM1pNMTYuMjkgMThINS4yOTAwNEw4LjA0MDA0IDE0LjQ3TDEwIDE2LjgzTDEyLjc1IDEzLjI5TDE2LjI5IDE4Wk0xOS4wOSA4Ljg5QzE5LjUzIDguMTkgMTkuNzkgNy4zOCAxOS43OSA2LjVDMTkuNzkgNC4wMSAxNy43OCAyIDE1LjI5IDJDMTIuOCAyIDEwLjc5IDQuMDEgMTAuNzkgNi41QzEwLjc5IDguOTkgMTIuOCAxMSAxNS4yOCAxMUMxNi4xNiAxMSAxNi45OCAxMC43NCAxNy42NyAxMC4zTDIwLjc5IDEzLjQyTDIyLjIxIDEyTDE5LjA5IDguODlaTTE1LjI5IDlDMTMuOTEgOSAxMi43OSA3Ljg4IDEyLjc5IDYuNUMxMi43OSA1LjEyIDEzLjkxIDQgMTUuMjkgNEMxNi42NyA0IDE3Ljc5IDUuMTIgMTcuNzkgNi41QzE3Ljc5IDcuODggMTYuNjcgOSAxNS4yOSA5WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ImageSearch = createIcon('ImageSearch', [
  [
    'path',
    {
      d: 'M17.79 13V20H3.79004V6H8.81004C8.86004 5.29 9.03004 4.62 9.29004 4H3.79004C2.69004 4 1.79004 4.9 1.79004 6V20C1.79004 21.1 2.69004 22 3.79004 22H17.79C18.89 22 19.79 21.1 19.79 20V15L17.79 13ZM16.29 18H5.29004L8.04004 14.47L10 16.83L12.75 13.29L16.29 18ZM19.09 8.89C19.53 8.19 19.79 7.38 19.79 6.5C19.79 4.01 17.78 2 15.29 2C12.8 2 10.79 4.01 10.79 6.5C10.79 8.99 12.8 11 15.28 11C16.16 11 16.98 10.74 17.67 10.3L20.79 13.42L22.21 12L19.09 8.89ZM15.29 9C13.91 9 12.79 7.88 12.79 6.5C12.79 5.12 13.91 4 15.29 4C16.67 4 17.79 5.12 17.79 6.5C17.79 7.88 16.67 9 15.29 9Z',
      key: 'ftayqu',
    },
  ],
]);

export default ImageSearch;
